import { Icon } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { MechanicStatusChip } from '../icons/MechanicStatusChip';
import { MoveToInProcess } from '../icons/MoveToInProcess';
import { MoveToWholeSale } from '../icons/MoveToWholeSale';

export const WOStatusChips = {
  IN_PROCESS: 'In Process',
  MECHANICAL: 'Mechanical',
  WHOLE_SALE: 'Wholesale',
};

const StyledContainer = styled('div')(() => ({
  display: 'flex',
}));

const StyledButton = styled('div', {
  shouldForwardProp: prop => prop !== 'backgroundColor' && prop !== 'color',
})(({ color, backgroundColor }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '4px 16px',
  gap: '5px',
  border: 'none',
  borderRadius: '50px',
  fontSize: '18px',
  background: backgroundColor,
  color: color,
  [`.MuiSvgIcon-root`]: {
    fontSize: '18px',
  },
  [`.MuiIcon-root`]: {
    width: '24px',
    height: '24px',
    [`svg`]: {
      width: '24px',
      height: '24px',
    },
  },
  [`.MuiFormControlLabel-label`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    lineHeight: '24px',
  },
}));
export const OrderStatusTag = ({ status = WOStatusChips.MECHANICAL }) => {
  const getColors = statusTag => {
    switch (statusTag) {
      case WOStatusChips.IN_PROCESS:
        return {
          backgroundColor: '#FF9800',
          text: 'In Process',
          icon: <MoveToInProcess color="white" />,
        };
      case WOStatusChips.MECHANICAL:
        return {
          backgroundColor: '#616161',
          text: 'Mechanical',
          icon: <MechanicStatusChip color="white" />,
        };
      case WOStatusChips.WHOLE_SALE:
        return {
          backgroundColor: '#E31B0C',
          text: 'Wholesale',
          icon: <MoveToWholeSale color="white" />,
        };
      default:
        return {
          backgroundColor: '#616161',
          text: 'Mechanical',
          icon: <MechanicStatusChip color="white" />,
        };
    }
  };

  const { backgroundColor, icon, text } = getColors(status);
  return (
    <StyledContainer>
      <StyledButton color="white" backgroundColor={backgroundColor}>
        <Icon fontSize="small">{icon}</Icon>
        <span style={{ fontSize: '12px' }}>{text}</span>
      </StyledButton>
    </StyledContainer>
  );
};
